import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import NewActionsHeader from '@src/containers/Layout/NewActionsHeader';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ROUTES from '@src/constants/route';
import actions from '@src/redux/actions';
import { NEW_ACTIONS_HEADER_MENU } from '@src/constants';
import { useMediaQuery } from '@mui/material';
import theme from '@src/styles/theme';
import { StyledVoiceLibraryHeader } from './index.style';

const Header = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <StyledVoiceLibraryHeader>
      <Typography variant="body-24-bold">{t('voiceLibrary')}</Typography>
      {!isMobile && (
        <NewActionsHeader
          menuShow={[
            NEW_ACTIONS_HEADER_MENU.TASK_CREDIT,
            NEW_ACTIONS_HEADER_MENU.GUIDE_CREDIT,
            NEW_ACTIONS_HEADER_MENU.LEADERBOARD_VOICE,
            NEW_ACTIONS_HEADER_MENU.NOTIFICATION,
          ]}
          onTaskCredits={() =>
            dispatch(actions.layout.setShowOnboardingPopup(true))
          }
          onLeaderboardVoice={() => {
            history.push(ROUTES.VOICE_LEADERBOARD);
          }}
          margin="0px"
        />
      )}
    </StyledVoiceLibraryHeader>
  );
};

export default Header;
